import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, DialogActions } from "@mui/material";

const titleSx = {
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 600,
  fontSize: '0.9rem',
  lineHeight: 1.4,
  py: 1.5,
  px: 2.5,
};

const closeBtnSx = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: '0.78rem',
  fontWeight: 500,
  textTransform: 'none',
  minWidth: 'auto',
  px: 2,
};

export default function MUIModal(props) {
  const {
    open,
    handleClose,
    children,
    title,
    child,
    action,
    hideClose,
    maxWidth,
    minWidth,
    ...rest
  } = props;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth ? maxWidth : "lg"}
      minwidth ={minWidth ? minWidth : 150}
      fullWidth={true}
      scroll="body"
      {...rest}
    >
      <DialogTitle variant="subtitle1" sx={titleSx}>
        {title}
        {child}
      </DialogTitle>
      <DialogContent sx={{ px: 2.5, py: 1.5, fontSize: '0.82rem' }}>{children}</DialogContent>
      <DialogActions sx={{ px: 2.5, py: 1.5 }}>
        {action}
        {!hideClose && <Button onClick={handleClose} sx={closeBtnSx}>Close</Button>}
      </DialogActions>
    </Dialog>
  );
}
